module.exports = __webpack_public_path__ + "static/media/mercadolibreicon.faf201f8.png";